// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__m8Vdf","navBar":"Layout_navBar__i0Yap","mainContent":"Layout_mainContent__Bq4qw","white":"Layout_white__8Rp7a","grey":"Layout_grey__IzPTW"};